'use es6';

export const WWW_FORM_CONTENT_TYPE = 'application/x-www-form-urlencoded';